import { render, staticRenderFns } from "./PrintResults.vue?vue&type=template&id=ef46546a&scoped=true&"
import script from "./PrintResults.vue?vue&type=script&lang=js&"
export * from "./PrintResults.vue?vue&type=script&lang=js&"
import style0 from "./PrintResults.vue?vue&type=style&index=0&id=ef46546a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef46546a",
  null
  
)

export default component.exports